// import amazonLiteUrl from "https://drive.google.com/file/d/14IsLWWNXYkgMGgo-DoU_RHNaCCa6NoVY/view?usp=sharing";
const projectList = [
	{
		id: 1,
		name: "React Small Website Ecommerce",
		description:
			"This is a small responsive webiste packed with ecommerce-like functionality",
		projectUrl: "https://mellow-biscochitos-cf9445.netlify.app",
		imageUrlL:
			"https://images.unsplash.com/photo-1472851294608-062f824d29cc?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=870&q=80",
	},
	{
		id: 2,
		name: "Fullstack blog website ",
		description:
			"This is a blog website which provides posting blog writing or login and signup functionality with Nodejs and monoodb.",
		projectUrl: "https://comfy-empanada-6d0317.netlify.app",
		imageUrlL:
			"https://images.unsplash.com/photo-1471107340929-a87cd0f5b5f3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=773&q=80",
	},
	{
		id: 3,
		name: "MongoDB developer",
		description:
			"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minima  optio modi saepe nulla error libero ratione labore dolorum earum!",
		imageUrlL:
			"https://images.unsplash.com/photo-1674720694029-f7e028dfc96e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=871&q=80",
		projectUrl: "",
	},
	{
		id: 4,
		name: "Nodejs developer",
		description:
			"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minima asperiores optio modi saepe nulla error libero ratione labore dolorum earum!",
		imageUrlL:
			"https://images.unsplash.com/photo-1674720694029-f7e028dfc96e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=871&q=80",
		projectUrl: "",
	},
	{
		id: 5,
		name: "Express.js developer",
		description:
			"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minima asperiores optio modi saepe nulla error libero ratione labore dolorum earum!",
		imageUrlL:
			"https://images.unsplash.com/photo-1674720694029-f7e028dfc96e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=871&q=80",
		projectUrl: "",
	},
	{
		id: 6,
		name: "Express.js developer",
		description:
			"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Minima asperiores optio modi saepe nulla error libero ratione labore dolorum earum!",
		imageUrlL:
			"https://images.unsplash.com/photo-1674720694029-f7e028dfc96e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=871&q=80",
		projectUrl: "",
	},
];
export default projectList;
